{
  "nl": {
    "wordClouds": {
      "buttons": {
        "addWord": "Woord toevoegen"
      },
      "headers": {
        "options": "Opties",
        "wordCloud": "Woordwolk"
      },
      "labels": {
        "show": "Woordwolk weergeven",
        "showBeforeSubmit": "Woordwolk zichtbaar vóór woordinvoer",
        "visitorCanWrite": "Bezoeker kan woorden toevoegen",
        "wordOccurences": "Woorden met frequentie",
        "words": "Woorden (één woord per regel)"
      },
      "links": {
        "save": "Woordwolk opslaan als afbeelding"
      },
      "placeholders": {
        "addWord": "Woord toevoegen..."
      }
    }
  }
}
